import { Directive, ElementRef, Input, OnInit, inject } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Directive({
    selector: '[appDisabledReason]',
    standalone: false
})
export class DisabledReasonDirective implements OnInit {
    private elementRef = inject(ElementRef);
    private translate = inject(TranslateService);


    private disabledReasonValue = null;

    @Input()
    set appDisabledReason(val: string) {
        this.disabledReasonValue = val;
        this.updateState();
    }

    ngOnInit() {
        this.updateState();
    }

    private updateState(): void {
        if (!this.disabledReasonValue) {
            this.elementRef.nativeElement.removeAttribute('title');
            this.elementRef.nativeElement.removeAttribute('disabled');
        } else {
            this.elementRef.nativeElement.setAttribute('title', this.translate.instant(this.disabledReasonValue));
            this.elementRef.nativeElement.setAttribute('disabled', 'disabled');
        }
    }

}
